import { type PropsWithChildren, createContext, useContext } from 'react';

const InsideDialogContext = createContext<HTMLElement | null>(null);

export const InsideDialogProvider = ({ children, value }: PropsWithChildren<{ value: HTMLElement | null }>) => (
  <InsideDialogContext.Provider value={value}>{children}</InsideDialogContext.Provider>
);

/**
 * The dialog content element. A menu portaled there escapes clipping ancestors while staying
 * inside the dialog's own stacking and pointer-event context. Null outside a dialog.
 */
export const useInsideDialogContentElement = () => useContext(InsideDialogContext);
